module.exports = __webpack_public_path__ + "static/img/30018 (4).027b226.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30018 (4).webp
// module id = CQfg
// module chunks = 14